import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "phoneNumber",
    "email",
    "address",
    "address2",
    "city",
    "state",
    "zip",
    "projectType",
    "hiddenCustomerName",
  ];

  customerSelected(event) {
    if (event.detail.value === "") {
      this.element.reset();
      this.clearDatalist(this.phoneNumberTarget, "phone-numbers");
      this.clearDatalist(this.emailTarget, "emails");
      return;
    }

    try {
      const address = JSON.parse(event.detail.value);

      if (typeof address === "object" && address !== null) {
        this.populateAddress(address);
        this.populateFieldWithDatalist(
          this.phoneNumberTarget,
          address.phone_numbers,
          "phone-numbers"
        );
        this.populateFieldWithDatalist(this.emailTarget, address.emails, "emails");
      } else {
        this.hiddenCustomerNameTarget.value = address;
      }
    } catch (err) {
      // they entered a new customer name, so the detail wasn't JSON
      this.hiddenCustomerNameTarget.value = event.detail.value;
    }
  }

  populateAddress(address) {
    this.hiddenCustomerNameTarget.value = address.customer_name;

    if (address.street) {
      this.addressTarget.value = address.street;
      this.addressTarget.dispatchEvent(new Event("input"));
    }

    if (address.unit) {
      this.address2Target.value = address.unit;
    }

    if (address.state) {
      this.stateTarget.value = address.state;
    }

    if (address.city) {
      this.cityTarget.value = address.city;
    }

    if (address.zip) {
      this.zipTarget.value = address.zip;
    }

    const projectTypeRadio = this.projectTypeTargets.find(
      (radio) => radio.value === address.customer_type
    );

    if (projectTypeRadio) {
      projectTypeRadio.checked = true;
    }
  }

  populateFieldWithDatalist(target, items, datalistPrefix) {
    this.clearDatalist(target, datalistPrefix);

    if (!items || items.length === 0) {
      target.value = "";
      return;
    }

    if (items.length === 1) {
      target.value = this.getItemValue(items[0]);
    } else {
      target.value = "";
      this.createDatalist(target, items, datalistPrefix);
    }
  }

  createDatalist(target, items, datalistPrefix) {
    const datalistId = `${datalistPrefix}-datalist`;
    const datalist = document.createElement("datalist");
    datalist.id = datalistId;

    items.forEach((item) => {
      const option = document.createElement("option");
      option.value = this.getItemValue(item);
      option.label = this.getItemLabel(item);
      datalist.appendChild(option);
    });

    target.setAttribute("list", datalistId);
    target.parentNode.appendChild(datalist);
  }

  getItemValue(item) {
    return typeof item === "object" ? item.value : item;
  }

  getItemLabel(item) {
    if (typeof item === "object") {
      return item.label;
    }

    return item;
  }

  clearDatalist(target, datalistPrefix) {
    const datalistId = `${datalistPrefix}-datalist`;
    const existingDatalist = document.getElementById(datalistId);
    if (existingDatalist) {
      existingDatalist.remove();
    }

    if (target) {
      target.removeAttribute("list");
    }
  }
}
